import type { ProcessActivityStatus, ServiceCode } from '@common/enums';
import type { GroupMeetingPatientAttendance } from '@common/enums/groupMeetingPatientAttendanceType';
import type { GroupMeetingType } from '@common/enums/groupMeetingType';
import type { IPatient } from './patient';

export enum GroupMeetingStatus {
    completed = 'completed',
    deleted = 'deleted',
    planned = 'planned',
}
export interface IGroupMeetingPatientWithRequestInformation {
    attendanceType?: GroupMeetingPatientAttendance;
    id: string;
    interimMdoRemark?: InterimMdoRemark;
    noShowsCount?: number;
    otherRemark?: string;
    process: {
        patient: IPatient;
        patientId: string;
        service: {
            code: ServiceCode;
        };
    };
    processId: string;
    regularMdoRemark?: string;
    reportStatus?: ProcessActivityStatus;
    requestDate?: string;
    requestStatus?: string;
}

export type InterimMdoRemark = {
    dietitianRemark?: string;
    psychologistRemark?: string;
};

export interface IPatientGroupMeetingManagement {
    birthDate?: Date | string;
    id: string;
    identifierSocialSecurity?: string | null;
    nameFamily?: string;
    nameGiven?: string | null;
}

export interface IGroupMeetingWithPatients {
    date: Date | string | null;
    endTime: string | null;
    groupMeetingPatients: IGroupMeetingPatientWithRequestInformation[];
    id: string;
    organizationId: string;
    patientsTotalCount: number;
    startTime: string | null;
    status?: GroupMeetingStatus;
    type: GroupMeetingType;
}
